import { axiosAuthClient } from '..';
import { handleError } from '../../utils/errors';

class AuthService {
  signUp = async ({ email, password, code }) => {
    try {
      const body = {
        email,
        password,
        code,
      };
      const response = await axiosAuthClient.post('/register', body);
      if (response.status !== 201) {
        throw new Error();
      }
      const { accessToken, vendor, refreshToken } = response.data.data;

      return { accessToken, refreshToken, vendor };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating new user');
    }
  };

  login = async ({ email, password }) => {
    try {
      const response = await axiosAuthClient.post('/login', {
        email,
        password,
      });
      if (response.status !== 201) {
        throw new Error();
      }
      const { accessToken, vendor, refreshToken } = response.data.data;

      return { accessToken, refreshToken, vendor };
    } catch (err) {
      throw handleError(err, 'Error occurred while logging in');
    }
  };

  logout = async refreshToken => {
    try {
      const response = await axiosAuthClient.post('/logout', { refreshToken });
      if (response.status !== 200) {
        throw new Error();
      }
      return;
    } catch (err) {
      throw handleError(err, 'Error occurred while logging out');
    }
  };

  verifyEmail = async email => {
    try {
      const response = await axiosAuthClient.post('/sendCode/vendor', { email });
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while signing up new user');
    }
  };

  sendRecoveryCodeForgotPassword = async email => {
    try {
      const response = await axiosAuthClient.post('/recoveryCode/vendor', { email });
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while sending recovery code.');
    }
  };

  changePassword = async formData => {
    try {
      const response = await axiosAuthClient.put(`/change-password/vendor`, formData);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while changing password.');
    }
  };
  renewCodeForVendor = async formData => {
    try {
      const response = await axiosAuthClient.put(`/renewCode/vendor`, formData);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while renew code.');
    }
  };
}
const authService = new AuthService();

export default authService;
